export default {
  currency: 'R$',
  researcherMonth: '53',
  totalResearcherMonth: '106',
  researcherYear: '33',
  totalResearcherYear: '66',
  totalYear: '403',
  promotion: 'brl_discount',
  locale: 'br',
};
